import {
  ha as asList,
  s9 as THROW_CCE,
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  a1 as Unit_getInstance,
  e1 as ArrayList,
  y9 as ensureNotNull,
  p5 as classMeta,
  j1 as LinkedHashMap,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
  }
  d4c(document) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = asList(document.querySelectorAll('tabview'));
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.editor.technology.gui.widgets.Companion.initialise.<anonymous>' call
      new TabView(element instanceof Element ? element : THROW_CCE());
    }
  }
}
class TabView {
  constructor(element) {
    Companion_getInstance();
    this.e4c_1 = element;
    var nav = this.g4c().createElement('tab-nav');
    this.e4c_1.insertBefore(nav, this.e4c_1.firstElementChild);
    var firstHeader = null;
    var firstTab = null;
    // Inline function 'kotlin.collections.forEach' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_filterIsInstance = asList(this.e4c_1.querySelectorAll(':scope > tab'));
    var tmp$ret$0;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filterIsInstance.u();
    while (tmp0_iterator.h1()) {
      var element_0 = tmp0_iterator.j1();
      if (element_0 instanceof Element) {
        tmp0_filterIsInstanceTo.e1(element_0);
      }
    }
    tmp$ret$0 = tmp0_filterIsInstanceTo;
    tmp$ret$1 = tmp$ret$0;
    var tmp1_forEach = tmp$ret$1;
    var tmp0_iterator_0 = tmp1_forEach.u();
    while (tmp0_iterator_0.h1()) {
      var element_1 = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.editor.technology.gui.widgets.TabView.<anonymous>' call
      var header = this.g4c().createElement('tab-header');
      nav.appendChild(header);
      header.textContent = element_1.getAttribute('id');
      header.addEventListener('click', TabView$lambda(this, header, element_1));
      if (null == firstHeader) {
        firstHeader = header;
        firstTab = element_1;
      }
    }
    if (!(null == firstHeader)) {
      this.f4c(ensureNotNull(firstHeader), ensureNotNull(firstTab));
    }
  }
  g4c() {
    return ensureNotNull(this.e4c_1.ownerDocument);
  }
  f4c(header, tab) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_filterIsInstance = asList(this.e4c_1.querySelectorAll(':scope > tab-nav > tab-header'));
    var tmp$ret$0;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filterIsInstance.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      if (element instanceof Element) {
        tmp0_filterIsInstanceTo.e1(element);
      }
    }
    tmp$ret$0 = tmp0_filterIsInstanceTo;
    tmp$ret$1 = tmp$ret$0;
    var tmp1_forEach = tmp$ret$1;
    var tmp0_iterator_0 = tmp1_forEach.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.editor.technology.gui.widgets.TabView.tabSelect.<anonymous>' call
      element_0.classList.remove('tab-active');
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp$ret$3;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp2_filterIsInstance = asList(this.e4c_1.querySelectorAll(':scope > tab'));
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo_0 = ArrayList.i4();
    var tmp0_iterator_1 = tmp2_filterIsInstance.u();
    while (tmp0_iterator_1.h1()) {
      var element_1 = tmp0_iterator_1.j1();
      if (element_1 instanceof Element) {
        tmp0_filterIsInstanceTo_0.e1(element_1);
      }
    }
    tmp$ret$2 = tmp0_filterIsInstanceTo_0;
    tmp$ret$3 = tmp$ret$2;
    var tmp3_forEach = tmp$ret$3;
    var tmp0_iterator_2 = tmp3_forEach.u();
    while (tmp0_iterator_2.h1()) {
      var element_2 = tmp0_iterator_2.j1();
      // Inline function 'net.akehurst.language.editor.technology.gui.widgets.TabView.tabSelect.<anonymous>' call
      element_2.setAttribute('style', 'display : none');
    }
    header.classList.add('tab-active');
    tab.setAttribute('style', 'display : grid');
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
  }
  h4c(document) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    var map = tmp$ret$0;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = asList(document.querySelectorAll('treeview'));
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.editor.technology.gui.widgets.Companion.initialise.<anonymous>' call
      var treeview = element instanceof Element ? element : THROW_CCE();
      var tmp = treeview.getAttribute('id');
      var id = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
      var tv = new TreeView(treeview);
      // Inline function 'kotlin.collections.set' call
      map.m3(id, tv);
    }
    return map;
  }
}
class TreeView {
  constructor(element) {
    Companion_getInstance_0();
    this.i4c_1 = element;
    this.j4c_1 = this.g4c().createElement('div');
    this.k4c_1 = false;
    this.l4c_1 = null;
    this.j4c_1.setAttribute('class', 'treeview-loading');
  }
  g4c() {
    return ensureNotNull(this.i4c_1.ownerDocument);
  }
  q4c(value) {
    this.k4c_1 = value;
    showLoading(this, value);
  }
  r4c(roots) {
    this.n1();
    if (roots.y()) {
      this.p4c(this.i4c_1, null, '<Empty>');
    } else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = roots.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.editor.technology.gui.widgets.TreeView.setRoots.<anonymous>' call
        this.p4c(this.i4c_1, element, element);
      }
    }
  }
  n1() {
    while (!(null == this.i4c_1.firstChild)) {
      this.i4c_1.removeChild(ensureNotNull(this.i4c_1.firstChild));
    }
  }
  p4c(parentElement, root, node) {
    if (ensureNotNull(this.l4c_1).n4c_1(node)) {
      var branchEl = this.g4c().createElement('treeview-branch');
      parentElement.append(branchEl);
      this.s4c(branchEl, ensureNotNull(this.l4c_1).m4c_1(root, node));
      var childrenEl = this.g4c().createElement('treeview-children');
      branchEl.append(childrenEl);
      branchEl.addEventListener('click', TreeView$addNode$lambda(branchEl, childrenEl, this, node, root));
    } else {
      var leafEl = this.g4c().createElement('treeview-leaf');
      parentElement.append(leafEl);
      this.s4c(leafEl, ensureNotNull(this.l4c_1).m4c_1(root, node));
      leafEl.addEventListener('click', TreeView$addNode$lambda_0);
    }
  }
  s4c(nodeElement, label) {
    var span = this.g4c().createElement('span');
    span.append(label);
    nodeElement.appendChild(span);
  }
}
class TreeViewFunctions {
  constructor(label, hasChildren, children) {
    this.m4c_1 = label;
    this.n4c_1 = hasChildren;
    this.o4c_1 = children;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function TabView$lambda(this$0, $header, $element) {
  return function (_anonymous_parameter_0__qggqh8) {
    this$0.f4c($header, $element);
    return Unit_getInstance();
  };
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function showLoading($this, visible) {
  while (!(null == $this.i4c_1.firstChild)) {
    $this.i4c_1.removeChild(ensureNotNull($this.i4c_1.firstChild));
  }
  if (visible) {
    $this.i4c_1.appendChild($this.j4c_1);
  }
}
function TreeView$addNode$lambda($branchEl, $childrenEl, this$0, $node, $root) {
  return function (it) {
    it.stopPropagation();
    var tmp;
    if (null == $branchEl.getAttribute('open')) {
      $branchEl.setAttribute('open', 'true');
      tmp = Unit_getInstance();
    } else {
      $branchEl.removeAttribute('open');
      tmp = Unit_getInstance();
    }
    var tmp_0;
    if (null == $childrenEl.firstChild) {
      var children = ensureNotNull(this$0.l4c_1).o4c_1($node);
      var indexedObject = children;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'net.akehurst.language.editor.technology.gui.widgets.TreeView.addNode.<anonymous>.<anonymous>' call
        this$0.p4c($childrenEl, $root, element);
      }
      tmp_0 = Unit_getInstance();
    }
    return Unit_getInstance();
  };
}
function TreeView$addNode$lambda_0(it) {
  it.stopPropagation();
  return Unit_getInstance();
}
//region block: post-declaration
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(TabView, 'TabView', classMeta);
setMetadataFor(Companion_0, 'Companion', objectMeta);
setMetadataFor(TreeView, 'TreeView', classMeta);
setMetadataFor(TreeViewFunctions, 'TreeViewFunctions', classMeta);
//endregion
//region block: exports
export {
  Companion_getInstance as a,
  Companion_getInstance_0 as b,
  TreeViewFunctions as c,
};
//endregion

//# sourceMappingURL=net.akehurst.language.editor.browser.demo-technology-gui-widgets.mjs.map
